var VolunteerJob;
(function (VolunteerJob) {
    var councilID = $("#volunteerJobs").data("council") ? $("#volunteerJobs").data("council") : $("#Council_CouncilRegionID").val();
    var geoID = $("#GeogrpahyID").val();
    var isInfo = $("#volunteerJobs").data("council") ? false : true;
    var searchResults = new Array();
    var currentSortTitle = false;
    var currentSortDate = true;
    var SearchModel = /** @class */ (function () {
        function SearchModel() {
        }
        return SearchModel;
    }());
    function setupPagination(total, pageNo) {
        var pageLinks = "";
        var pageSize = 10;
        var numberOfPages = Math.floor(total / pageSize);
        if (total % pageSize > 0)
            numberOfPages++;
        if (numberOfPages <= 1 || typeof pageNo === "undefined") {
            $(".mcd-pagination").hide();
            return;
        }
        var startPage = 1;
        var endPage = numberOfPages;
        var maxDisplayPages = 11;
        if (numberOfPages > maxDisplayPages) {
            startPage = pageNo - Math.floor((maxDisplayPages - 1) / 2);
            if (startPage <= 0)
                startPage = 1;
            endPage = startPage + maxDisplayPages;
            if (endPage > numberOfPages) {
                endPage = numberOfPages;
                startPage = endPage - maxDisplayPages;
            }
        }
        if (pageNo > 1)
            pageLinks += '<a href="#" data-page="' + (pageNo - 1) + '" class="pickPage previous">Previous</a>';
        if (startPage > 1) {
            pageLinks += '<a href="#" data-page="1" class="number pickPage">1</a> ... ';
        }
        for (var i = startPage; i <= endPage; i++) {
            pageLinks += '<a href="#" data-page="' + i + '" class="number ' + (i === pageNo ? 'current' : 'pickPage') + '">' + i + '</a>';
        }
        if (endPage < numberOfPages) {
            pageLinks += ' ... <a href="#" data-page="' + numberOfPages + '" class="number pickPage">' + numberOfPages + '</a>';
        }
        if (numberOfPages !== pageNo) {
            pageLinks += '<a href="#" data-page="' + (pageNo + 1) + '" class="pickPage next">Next</a>';
        }
        var pages = '<p>Page ' + pageNo + ' of ' + numberOfPages + '</p>';
        if (numberOfPages !== 1)
            pages += '<div class="pagination-links">' + pageLinks + '</div>';
        $(".mcd-pagination").html(pages);
        $(".mcd-pagination .pickPage").on("click", function (e) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "slow");
            performSearch(parseInt($(this).data("page")), currentSortDate, currentSortTitle);
        });
    }
    function performSearch(pageNumber, sortByDate, sorByTitle) {
        if (sortByDate === void 0) { sortByDate = true; }
        if (sorByTitle === void 0) { sorByTitle = false; }
        var pageNo = !pageNumber ? 1 : pageNumber;
        var searchRequest = new SearchModel();
        searchRequest.OrderByDate = sortByDate;
        searchRequest.OrderByVolunteerTitle = sorByTitle;
        searchRequest.CouncilID = councilID;
        searchRequest.Length = 10;
        searchRequest.Start = (pageNo - 1) * 10;
        searchRequest.IncludeCounts = true;
        searchRequest.GeographyID = parseInt(geoID);
        $.ajax({
            type: "POST",
            url: window.AppSettings.ApiUrl + "/api/v1/volunteer/search",
            data: JSON.stringify(searchRequest),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (res) {
                if (isInfo) {
                    if (res.Total === 0) {
                        $('.no-ad-wording').show();
                    }
                    searchResults = res.Results.slice(0, 3);
                }
                else {
                    searchResults = res.Results;
                }
                var today = Date.parse(new Date().toISOString().slice(0, 10));
                for (var i = 0; i < searchResults.length; i++) {
                    var endDate = Date.parse(searchResults[i].ValidToDateTimeUTC.toString().slice(0, 10));
                    var dateDiff = (endDate - today) / (1000 * 60 * 60 * 24);
                    searchResults[i].dateToExpire = dateDiff > 0 ? dateDiff.toString() : "0";
                }
                var total = res.Total;
                $("#results-text").html(total + " results");
                var results = $("#resultTemplate").render(searchResults);
                $("#searchresults").html(results);
                setupPagination(total, pageNo);
            },
            error: function () {
                McdMessages.Error("Search Results has Failed");
            },
            complete: function () {
                $("#busy-indicator").hide();
                $("#results").removeClass("dim");
                $("#results-summary-container").show();
            }
        });
    }
    function initSetup() {
        $("#sortByDate").on('click', function () {
            currentSortDate = true;
            currentSortTitle = false;
            performSearch(null, currentSortDate);
        });
        $("#sortByTitle").on('click', function () {
            currentSortDate = false;
            currentSortTitle = true;
            performSearch(null, currentSortDate, currentSortTitle);
        });
    }
    function Init() {
        initSetup();
        performSearch();
    }
    VolunteerJob.Init = Init;
})(VolunteerJob || (VolunteerJob = {}));
